import { homePageJurisdiction } from './jurisdiction/homePageJurisdiction'
import { basicServicesJurisdiction } from './jurisdiction/basicServicesJurisdiction'
import { investmentLeasingJurisdiction } from './jurisdiction/investmentLeasingJurisdiction'
import { accessControlJurisdiction } from './jurisdiction/accessControlJurisdiction'
import { parkingServiceJurisdiction } from './jurisdiction/parkingServiceJurisdiction'
import { electricServiceJurisdiction } from './jurisdiction/electricServiceJurisdiction'
import { messageServiceJurisdiction } from './jurisdiction/messageServiceJurisdiction'
import { appointmentServiceJurisdiction } from './jurisdiction/appointmentServiceJurisdiction'
// import { spaceServiceJurisdiction } from './jurisdiction/spaceServiceJurisdiction'
import { ladderControlJurisdiction } from './jurisdiction/ladderControlJurisdiction'
import { repairJurisdiction } from './jurisdiction/repairJurisdiction'
import { financeServiceJurisdiction } from './jurisdiction/financeServiceJurisdiction'
import { paymentServiceJurisdiction } from './jurisdiction/paymentServiceJurisdiction'
import { documentServiceJurisdiction } from './jurisdiction/documentServiceJurisdiction'
import { invoiceServiceJurisdiction } from './jurisdiction/invoiceServiceJurisdiction'
// import { agentServiceJurisdiction } from './jurisdiction/agentServiceJurisdiction'
// import { strictSelectionServiceJurisdiction } from './jurisdiction/strictSelectionServiceJurisdiction'
// import { activityServiceJurisdiction } from './jurisdiction/activityServiceJurisdiction'
// import { monitorServiceJurisdiction } from './jurisdiction/monitorServiceJurisdiction'
// import { fireControlServiceJurisdiction } from './jurisdiction/fireControlServiceJurisdiction'
// import { alarmServiceJurisdiction } from './jurisdiction/alarmServiceJurisdiction'
import { inspectionServiceJurisdiction } from './jurisdiction/inspectionServiceJurisdiction'
import { keepWatchServiceJurisdiction } from './jurisdiction/keepWatchServiceJurisdiction'
import { waterServiceJurisdiction } from './jurisdiction/waterServiceJurisdiction'
// import { dataServiceParkServiceJurisdiction } from './jurisdiction/dataServiceParkServiceJurisdiction'
// import { dataServiceEnterpriseServiceJurisdiction } from './jurisdiction/dataServiceEnterpriseServiceJurisdiction'
// import { dataIncubateServiceJurisdiction } from './jurisdiction/dataIncubateServiceJurisdiction'
// import { enterpriseFavourServiceJurisdiction } from './jurisdiction/enterpriseFavourServiceJurisdiction'
import { workAttendanceServiceJurisdiction } from './jurisdiction/WorkAttendanceJurisdiction'
// import { questionnaireServiceJurisdiction } from './jurisdiction/questionnaireServiceJurisdiction'
// import { materialsServiceJurisdiction } from './jurisdiction/materialsServiceJurisdiction'
// import {needHandleJurisdiction} from './jurisdiction/needHandleJurisdiction'
// import { smartDetectionJurisdiction } from './jurisdiction/smartDetectionJurisdiction'
// import { propertyFeeJurisdiction } from './jurisdiction/propertyFeeJurisdiction'
// import { groupJurisdiction } from './jurisdiction/groupJurisdiction'
// import { CustomerFlowJurisdiction } from './jurisdiction/CustomerFlowJurisdiction'
// import { faceRecognitionJurisdiction } from './jurisdiction/faceRecognitionJurisdiction'
// import {steamServiceJurisdiction} from './jurisdiction/steamServiceJurisdiction'
import {gasServiceJurisdiction} from './jurisdiction/gasServiceJurisdiction'
import { smartDoorLockJurisdiction } from './jurisdiction/smartDoorLockJurisdiction'

// 所有权限
const jurisdiction = [
  homePageJurisdiction,
  basicServicesJurisdiction,
  investmentLeasingJurisdiction,
  messageServiceJurisdiction,
  repairJurisdiction,
  keepWatchServiceJurisdiction,
  inspectionServiceJurisdiction,
  workAttendanceServiceJurisdiction,
  electricServiceJurisdiction,
  waterServiceJurisdiction,
  gasServiceJurisdiction,
  financeServiceJurisdiction,
  paymentServiceJurisdiction,
  invoiceServiceJurisdiction,
  accessControlJurisdiction,
  smartDoorLockJurisdiction,
  parkingServiceJurisdiction,
  ladderControlJurisdiction,
  appointmentServiceJurisdiction,

  // electricServiceJurisdiction,
  // spaceServiceJurisdiction,
  documentServiceJurisdiction,
  // agentServiceJurisdiction,
  // strictSelectionServiceJurisdiction,
  // activityServiceJurisdiction,
  // monitorServiceJurisdiction,
  // fireControlServiceJurisdiction,
  // alarmServiceJurisdiction,
  // {
  //   id: '028',
  //   label: '智慧大脑',
  //   routerName: 'interface-manage',
  //   children: [
  //     {
  //       id: '028001001',
  //       label: '智慧大脑',
  //       routerName: 'interface-manage',
  //       children: []
  //     }
  //   ]
  // },
  // dataServiceParkServiceJurisdiction,
  // dataServiceEnterpriseServiceJurisdiction,
  // dataIncubateServiceJurisdiction,
  // enterpriseFavourServiceJurisdiction,
  // questionnaireServiceJurisdiction,
  // materialsServiceJurisdiction,
  // needHandleJurisdiction,
  // smartDetectionJurisdiction,
  // propertyFeeJurisdiction,
  // groupJurisdiction,
  // CustomerFlowJurisdiction,
  // faceRecognitionJurisdiction,
  // steamServiceJurisdiction,
]

export { jurisdiction }



// WEBPACK FOOTER //
// ./src/utils/jurisdiction.js